import CarAsset from './CarAsset'

export default CarAsset
